<template>
  <div>
    <serveur-info :erreur="erreur" />
    <my-notification :icon="'lightbulb-o'">
      <template #title
        >{{ $t('compTransitionReviewerReviewActions.action-plans') }}
      </template>
      <p>
        {{ $t('compTransitionReviewerReviewActions.info') }}
      </p>
    </my-notification>
    <br />
    <div class="columns">
      <div class="column">
        <b-notification :closable="false">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ $t('compTransitionReviewerReviewActions.nActionsToReview') }}
              </p>
              <div class="title is-size-2">
                <p>
                  {{ nActionsToReview }}
                </p>
              </div>
            </div>
          </div>
        </b-notification>
      </div>
      <div class="column">
        <b-notification :closable="false">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{
                  $t('compTransitionReviewerReviewActions.nActionsToReviewLate')
                }}
              </p>
              <div class="title is-size-2">
                <p>
                  {{ nActionsToReviewLate }}
                </p>
              </div>
            </div>
          </div>
        </b-notification>
      </div>
      <div class="column">
        <b-notification :closable="false">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{
                  $t('compTransitionReviewerReviewActions.nActionsUnassigned')
                }}
              </p>
              <div class="title is-size-2">
                <p>
                  {{ nActionsUnassigned }}
                </p>
              </div>
            </div>
          </div>
        </b-notification>
      </div>
    </div>
    <actions-table
      :actions="actions"
      :searchable="true"
      :withActionId="true"
      :withReviewerColumn="true"
      :withLabColumn="true"
      :withReminderColumn="false"
      :withValidColumn="true"
    >
      <!-- custom stuff on the last column-->
      <template #custom="slotProps">
        <b-tooltip
          :label="$t('compTransitionReviewerReviewActions.action-assign')"
          type="is-black"
        >
          <b-button
            size="is-small"
            icon-left="list"
            @click="assignAction(slotProps.action)"
          />
        </b-tooltip>

        <b-tooltip
          :label="$t('compTransitionReviewerReviewActions.action-review')"
          type="is-black"
        >
          <b-button
            size="is-small"
            icon-left="eye"
            @click="reviewAction(slotProps.action)"
          />
        </b-tooltip>

        <b-tooltip
          :label="$t('compTransitionReviewerReviewActions.action-publish')"
          type="is-black"
        >
          <b-button
            size="is-small"
            icon-left="check"
            @click="confirmPublish(slotProps.action)"
          />
        </b-tooltip>
      </template>
    </actions-table>
  </div>
</template>

<script>
import { Background } from '@/mixins/background.js'
import transitionService from '@/services/transitionService.js'
import {
  PublicAction,
  insertOrUpdateInList
} from '@/models/transition/transition.js'

export default {
  name: 'GES1point5Admin',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue'),
    'serveur-info': () => import('@/components/ServeurInfo.vue'),
    'actions-table': () => import('@/components/transition/ActionsTable.vue')
  },
  mixins: [Background],
  data () {
    return {
      erreur: null,
      actions: [],
      currentLab: {},
      currentQuota: 0,
      currentMaxQuota: 0
    }
  },
  watch: {},
  methods: {
    confirmPublish (action) {
      this.$buefy.dialog.confirm({
        title: this.$t('compTransitionReviewerReviewActions.confirm-title'),
        message: this.$t('compTransitionReviewerReviewActions.ask-publish'),
        confirmText: this.$t('validate'),
        cancelText: this.$t('cancel'),
        canCancel: ['escape', 'button', 'outside'],
        onConfirm: () => this.publish(action)
      })
    },
    assignAction (action) {
      this.bgUI(async () => {
        let data = await transitionService.reviewerAssignAction(action.id)
        let newAction = PublicAction.fromDatabase(data)
        insertOrUpdateInList(this.actions, newAction)
      })
    },
    publish (action) {
      this.bgUI(async () => {
        let data = await transitionService.reviewerTogglePublishAction(
          action.id
        )
        let newAction = PublicAction.fromDatabase(data)
        insertOrUpdateInList(this.actions, newAction)
      })
    },
    /**
     * Open in a new tab
     * so that reviewer can review several actions in a row
     *
     * @param {} action
     */

    reviewAction (action) {
      let route = this.$router.resolve({
        path: `/transition-1point5/reviewer/actions/${action.id}`
      })
      window.open(route.href, '_blank')
    }
  },
  computed: {
    nActionsToReview: function () {
      return this.actions.filter((a) => a.isSubmitted()).length
    },
    nActionsToReviewLate: function () {
      return this.actions.filter((a) => a.isReviewLate()).length
    },
    nActionsUnassigned: function () {
      return this.actions.filter((a) => !a.isAssigned()).length
    }
  },
  mounted () {
    this.bgUI(async () => {
      let data = await transitionService.reviewerGetActions()
      this.actions = data.map((d) => PublicAction.fromDatabase(d))
    })
  }
}
</script>
